import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { IDoctorBasic } from "../../types";
import { CircleUserRound } from "lucide-react";
import { useParams } from "react-router-dom";



function DoctorCard({
  professionalId,
  profilePhoto,
  fullName,
  specialities,
  yearOfExperience,
  subDistrictOrCity,
  fee,
}: IDoctorBasic) {
  return (
    <Link
      to={`/doctors/${professionalId}`}
      className="max-sm:py-6 max-sm:first:pt-0 sm:rounded-lg sm:border sm:p-2 lg:p-4"
    >
      <li className="h-full">
        <div className="flex h-full gap-3">
          {profilePhoto ? (
            <img
            src={`${profilePhoto}`}
              alt={fullName || "Doctor"}
              className="size-16 rounded-full object-contain sm:size-20"
            />
          ) : (
            <div className="flex size-16 shrink-0 items-center justify-center rounded-full bg-muted sm:size-20">
              <CircleUserRound
                className="size-full"
                strokeWidth={1}
              />
            </div>
          )}
          <div className="flex w-full flex-col justify-between gap-4">
            <div>
              <h3 className="text-sm font-bold sm:text-lg">Dr {fullName || "Unknown"}</h3>
              <p className="mb-0.5 text-xs text-muted-foreground sm:text-sm">
                {specialities && specialities.length > 0 ? <>{specialities.join(", ")}, </> : "No specialties"}
                {yearOfExperience != null ? `${yearOfExperience} Years Exp.` : "No experience info"}
              </p>
              {subDistrictOrCity?.trim() ? (
  <p className="mb-1 text-xs font-bold text-muted-foreground sm:text-sm">
    {subDistrictOrCity}
  </p>
) : null}

              <p className="text-sm font-bold sm:text-base">
                Fee: ₹{fee != null ? fee : "NA"}
              </p>
            </div>
            <Button className="h-8 px-3 text-xs max-sm:h-7 max-sm:px-2 max-sm:text-[11px] max-sm:tracking-tighter">
              Book appointment
            </Button>
          </div>
        </div>
      </li>
    </Link>
  );
}

export default DoctorCard;
